import { render, staticRenderFns } from "./CohortsArr.vue?vue&type=template&id=15a31eea&scoped=true&"
import script from "./CohortsArr.vue?vue&type=script&lang=js&"
export * from "./CohortsArr.vue?vue&type=script&lang=js&"
import style0 from "./CohortsArr.vue?vue&type=style&index=0&id=15a31eea&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15a31eea",
  null
  
)

export default component.exports